(function () {
    var AboutController = /** @class */ (function () {
        function AboutController($mdDialog, $Config) {
            this.$mdDialog = $mdDialog;
            this.$Config = $Config;
            this.applicationVersion = this.$Config.version;
            this.versionCode = this.$Config.versionCode;
            this.showVersionCode = this.$Config.environment === 'dev';
        }
        /**
         * Close dialog
         */
        AboutController.prototype.closeDialog = function () {
            this.$mdDialog.cancel();
        };
        AboutController.$inject = ['$mdDialog', '$Config'];
        return AboutController;
    }());
    angular.module('internal.about', []).controller('AboutController', AboutController);
})();
